<div style="margin: 10px 10px 10px 0px;">
  <h1>PRTG</h1>
  <form [formGroup]="SettingsForm" (ngSubmit)="applyTempChanges()">
    <div class="row">
      <div class="uv-row">
        <label for="name" class="col-lg-2 col-form-label">Name:</label>
        <div class="col-lg-6">
          <input id="name" type="text" class="form-control" [ngClass]="{'is-invalid': !Name.valid}" [formControl]="Name" />
        </div>
      </div>
    </div>
    @if (Name.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-8 alert alert-danger error-message">Name is required</div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="row">
      <label for="serverUrl" class="col-lg-2 col-form-label">Server URL:</label>
      <div class="col-lg-6">
        <input id="serverUrl" type="text" class="form-control" [ngClass]="{'is-invalid': !ServerUrl.valid}" [formControl]="ServerUrl" />
      </div>
    </div>
    @if (ServerUrl.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-8 alert alert-danger error-message">Server URL is required</div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="mb-3 row">
      <span class="col-lg-2 col-form-label">&nbsp;</span>
      <div class="col-lg-10">
        <input type="checkbox" [formControl]="IsHostedPRTG" />
        <span class="uv-checkbox-label">Is Hosted PRTG</span>
      </div>
    </div>
    <div class="row">
      <label for="username" class="col-lg-2 col-form-label">User Name:</label>
      <div class="col-lg-6">
        <input id="username" type="text" class="form-control" [ngClass]="{'is-invalid': !Username.valid}" [formControl]="Username" />
      </div>
    </div>
    @if (Username.hasError('required')) {
      <div class="row">
        <div class="col-lg-8 alert alert-danger error-message">User Name is required</div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="row">
      <label for="passhash" class="col-lg-2 col-form-label">Passhash:</label>
      <div class="col-lg-6">
        <input id="passhash" [type]="PasswordInputType" class="form-control"
          [ngClass]="{'is-invalid': !Passhash.valid}" [formControl]="Passhash"
          (keydown)="onPasswordKeyDownHandler($event, 'Passhash')" />
        </div>
        <div class="col-lg-2">
          <button type="button" pButton label="Test PRTG Connection" title="Test/Verify PRTG connection credentials"
            [disabled]="!SettingsForm.valid"
          (click)="testPrtgConnect()"></button>
        </div>
      </div>
      @if (Passhash.hasError('required') || Passhash.hasError('minValue')) {
        <div class="row">
          @if (Passhash.hasError('required')) {
            <div class="col-lg-8 alert alert-danger error-message">Passhash is required</div>
          }
          @if (Passhash.hasError('minValue')) {
            <div class="col-lg-8 alert alert-danger error-message">Passhash must be a non-negative integer</div>
          }
        </div>
      }
      <div class="mb-3"></div>
      <div class="row">
        <div class="uv-row">
          <label for="servicePort" class="col-lg-2 col-form-label">UVexplorer PRTG Service Port:</label>
          <div class="col-lg-2 me-2">
            <input id="servicePort" type="text" class="form-control" [ngClass]="{'is-invalid': !ServicePort.valid}" [formControl]="ServicePort" />
          </div>
          <span class="col-form-label">(leave empty to use the default)</span>
        </div>
      </div>
      @if (ServicePort.hasError('minValue') || ServicePort.hasError('maxValue')) {
        <div class="mb-3 row">
          <div class="col-lg-4 alert alert-danger error-message">Service Port must be in the range 1 - 65535</div>
        </div>
      }
      <div class="mb-3"></div>
      <div class="mb-3 row">
        <div class="uv-row">
          <label for="serviceApiKey" class="col-lg-2 col-form-label">UVexplorer PRTG Service API Key:</label>
          <div class="col-lg-4 me-2">
            <input id="serviceApiKey" [type]="PasswordInputType" class="form-control"
              [ngClass]="{'is-invalid': !ServiceApiKey.valid}" [formControl]="ServiceApiKey"
              (keydown)="onPasswordKeyDownHandler($event, 'ServiceApiKey')" />
            </div>
            <span class="col-form-label">(leave empty if the service is not configured to use API keys)</span>
          </div>
        </div>
        <div class="mb-3 row">
          <label for="prtgShowChars" class="col-lg-2 col-form-label">&nbsp;</label>
          <div class="col-lg-2">
            <input id="prtgShowChars" type="checkbox" [formControl]="ShowChars"
              (change)="ToggleShowChars()" [ngClass]="{'is-invalid':!ShowChars.valid}" />
              <span class="uv-checkbox-label">Show Chars</span>
            </div>
          </div>
          <button type="submit" pButton [disabled]="!SettingsForm.valid || SettingsForm.pristine" label="Apply"></button>
        </form>
      </div>